
function onChangeHandler(ev) {
  if (ev.target.form && ev.target.form.dataset.showSubmit && ev.target.form.checkValidity()) {
    var show = false;
    var elements = ev.target.form.elements;
    Array.from(elements).forEach(function(element){
      console.log('type '+element.type)
      switch(element.type) {
        case 'text':
          if(element.value != ''){
            show = true
          }
          break;
        case 'checkbox':
          if(element.checked){
            show = element.checked;
          }
          break;
        case 'radio':
          if(element.checked) {
            show = element.checked;
          }
          break;
        case 'select-one':
          if(element.selectedIndex != '0'){
            show = true
          }
          break;
        case 'textarea':
          if(element.value != ''){
            show = true
          }
          break;
      }
    })

    var button = ev.target.form.querySelector('[data-submit]');
    var formType = ev.target.form.querySelector('#formType');

    if(button && formType.value !='') {
      var submitButton = button.querySelector('button');

      showHideSubmit(show)

      //delete mail
      if(formType && formType.value === 'delete'){
        var submitText = document.querySelector('[data-formType="delete"]');
        button.querySelector('button').innerHTML = submitText.dataset.submitText;
        submitButton.disabled = false;
      }

      //copy mail
      if(formType && formType.value === 'copy'){
        var submitCopyText = document.querySelector('[data-formType="copy"]');
        var copyToSelect = button.querySelector('[data-mail-copy]');
        if(copyToSelect && submitCopyText){
          copyToSelect.classList.remove('hide');
          var selectElement = copyToSelect.querySelector('select');

          if(selectElement){
            selectElement.addEventListener('change', function(){
              submitButton.disabled = false;
            })
          }

          submitButton.innerHTML = submitCopyText.dataset.submitText;
        } else {
          copyToSelect.classList.add('hide')
        }
      }

      //returnToInbox
      if(formType && formType.value === 'returnToInbox'){
        var submitReturnText = document.querySelector('[data-formType="returnToInbox"]');
        button.querySelector('button').innerHTML = submitReturnText.dataset.submitText;
        submitButton.disabled = false;
      }
    }
  }
}

function showHideSubmit(show){
  var button = document.querySelector('[data-submit]');
  if(button) {
    if (show) {
      button.classList.remove('hide');
      button.classList.add('fade-in');
    } else {
      button.classList.add('hide');
      button.classList.remove('fade-in');
    }
  }
}

var reset = function(){
  var button = document.querySelector('[data-submit]')

  if(button){
    button.classList.add('hide');
    button.classList.remove('fade-in');
    var copyToSelect = button.querySelector('[data-mail-copy]');
    var submitButton = button.querySelector('button');
    if(copyToSelect && submitButton){
      submitButton.disabled = true;
      var selectElement = copyToSelect.querySelector('select');
      if(selectElement){
        selectElement.selectedIndex = 0;
      }
      copyToSelect.classList.add('hide')
    }
  }
}


exports.reset = reset;
exports.showHideSubmit = showHideSubmit;

window.addEventListener('change', onChangeHandler)
window.addEventListener('keyup', onChangeHandler)
window.addEventListener('listChangeRemoveItem', showHideSubmit, true)
window.addEventListener('reset', reset)